import React, { Component } from "react";
import SchoolFilterGroup from "./components/SchoolFilterGroup";
import "./style.css";
import "../../../index.css";
class SchoolFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limits: [],
      schoolLevelIds: [],
      schoolTagIds: [],
      schoolPropertyIds: [],
      provinceIds: [],
      pageNum: 1,
      pageSize: 20,
    };
  }
  render() {
    const { visible, handleVisibleFilter, filterData } = this.props;
    return (
      <div
        className={
          visible === true
            ? "school_filter_box"
            : "school_filter_box display_none"
        }
      >
        <div className="school_filter_inline_box fr">
          {filterData != null ? (
            <div>
              {filterData.map((item, index) => {
                return (
                  <SchoolFilterGroup
                    onRef={this.onRef.bind(this)}
                    key={index}
                    name={item.name}
                    filters={item.filters}
                    handleChangState={this.handleChangState.bind(this)}
                  ></SchoolFilterGroup>
                );
              })}
              <div style={{ height: 60 }}></div>
              <div className="school_filter_inline_box_bottom">
                <div className="school_filter_inline_box_bottom_inline">
                  <div
                    onClick={() => this.handleReset()}
                    className="major_filter_inline_box_bottom_btn_fl fl"
                  >
                    重置
                  </div>
                  <div
                    onClick={() => this.handleConfirm()}
                    className="major_filter_inline_box_bottom_btn_fr fr"
                  >
                    确定
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div
          onClick={handleVisibleFilter}
          className="school_filter_inline_click fl"
        ></div>
      </div>
    );
  }
  /**
   * 让子组件调用改变当前父组件的状态值
   */
  handleChangState = (stateName) => {
    setTimeout(() => {
      this.setState(stateName);
      this.props.handleChangeParams(this.state);
      this.props.handleAddScroll();
    });
  };
  /**
   * 重置高校过滤组件的数据
   */
  handleReset = () => {
    this.schoolFilterGroup.resetUIState();
    setTimeout(() => {
      this.setState({
        schoolLevelIds: [],
        schoolTagIds: [],
        schoolPropertyIds: [],
        provinceIds: [],
        limits: [],
        pageNum: 1,
        pageSize: 20,
      });
      this.props.handleChangeParams(this.state);
      this.props.handleAddScroll();
    });
  };
  /**
   * 高校过滤组件确定事件
   */
  handleConfirm = () => {
    setTimeout(() => {
      localStorage.setItem("schoolFilter", JSON.stringify(this.state));
      this.props.handleChangeParams(this.state);
      this.props.requestFilterSchoolList();
      this.props.handleVisibleFilter();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
  };
  // 获取子组件
  onRef = (name, ref) => {
    switch (name) {
      case "schoolFilterGroup":
        this.schoolFilterGroup = ref;
        break;
      default:
        break;
    }
  };
}
export default SchoolFilter;



// WEBPACK FOOTER //
// ./src/components/School/SchoolFilter/index.js